import './index.css';

export default function Main({ children }: { children: React.ReactElement }) {
    return <main>{children}</main>;
}
